// extracted by mini-css-extract-plugin
export var statItem = "_m6-1";
export var statsRow = "_m6-0";